export const REDIRECT_BLOCKING_PURPOSES = {
    APPROVAL: "Approval",
    ASSET: "Asset",
    COMMENT: "Comment",
    GENERIC: "Generic",
    FEEDBACK: "Feedback",
    MAPPING: "Mapping",
    ACCOUNT_SETTINGS: "Account settings"
};
